export default "/images/regin_logo_bw.svg?29c416ad51da9b0a4a15b66ad500a965";